var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Formulario Cotización" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "padding-right": "20px",
                    display: "block",
                    margin: "13px 10px 0 auto",
                    height: "38px"
                  },
                  attrs: { color: "#ffe800" },
                  on: { click: _vm.guardar }
                },
                [
                  _c("span", { staticStyle: { color: "black" } }, [
                    _vm._v("Guardar")
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "padding-right": "20px",
                    display: "block",
                    margin: "13px 0 0 auto",
                    height: "38px"
                  },
                  attrs: { color: "#ffe800" },
                  on: { click: _vm.enviar }
                },
                [
                  _c("span", { staticStyle: { color: "black" } }, [
                    _vm._v("Enviar")
                  ])
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: {
          pasos: _vm.id_cotizacion != "" ? _vm.pasos2 : _vm.pasos,
          "validar-paso": false
        },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { titulo: "Datos Identificación" } },
                              [
                                _vm._t("prependInformacionGeneral"),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.rut.label,
                                        items: _vm.clientList,
                                        "item-text": "rut_cliente",
                                        "item-value": "rut_cliente",
                                        "error-messages": _vm.errors.collect(
                                          "rutVal"
                                        ),
                                        "data-vv-name": "rutVal",
                                        clearable: "",
                                        required: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.selectClient("rut")
                                        }
                                      },
                                      model: {
                                        value: _vm.formFields.rut.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.rut,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.rut.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-combobox", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.razon_social.label,
                                        items: _vm.clientList,
                                        "item-text": "razon_social",
                                        "item-value": "razon_social",
                                        "error-messages": _vm.errors.collect(
                                          "reasonVal"
                                        ),
                                        "data-vv-name": "reasonVal",
                                        clearable: "",
                                        required: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectClient("razon")
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.razon_social.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.razon_social,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.razon_social.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-flex", { attrs: { sm4: "", md4: "" } }),
                                _c(
                                  "v-flex",
                                  { attrs: { sm3: "", md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.nombreContacto.label,
                                        "error-messages": _vm.errors.collect(
                                          "nameContactVal"
                                        ),
                                        "data-vv-name": "nameContactVal",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.nombreContacto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.nombreContacto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.nombreContacto.value"
                                      }
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-style": "italic",
                                          margin: "0 auto",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Puede ingresar varios Contactos con sus respectivos\n                      Emails separados por punto y coma (;)"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm3: "", md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|emailFormat",
                                          expression: "'required|emailFormat'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.emailContacto.label,
                                        "error-messages": _vm.errors.collect(
                                          "emailContactVal"
                                        ),
                                        "data-vv-name": "emailContactVal",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.emailContacto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.emailContacto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.emailContacto.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm3: "", md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:11|numeric",
                                          expression:
                                            "'required|max:11|numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.phoneContacto.label,
                                        "error-messages": _vm.errors.collect(
                                          "telefonoFijo"
                                        ),
                                        "data-vv-name": "telefonoFijo",
                                        placeholder: "56299999999",
                                        counter: 11,
                                        type: "tel",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.phoneContacto.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.phoneContacto,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.phoneContacto.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm3: "", md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:50",
                                          expression: "'required|max:50'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.direccion.label,
                                        "error-messages": _vm.errors.collect(
                                          "directionVal"
                                        ),
                                        "data-vv-name": "directionVal",
                                        counter: 50,
                                        required: ""
                                      },
                                      model: {
                                        value: _vm.formFields.direccion.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.direccion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.direccion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:29",
                                          expression: "'required|max:29'"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.formFields.ejecutivo.label,
                                        "error-messages": _vm.errors.collect(
                                          "leadershipVal"
                                        ),
                                        "data-vv-name": "leadershipVal",
                                        counter: 29,
                                        required: "",
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.formFields.ejecutivo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.ejecutivo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.ejecutivo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|max:50",
                                          expression: "'required|max:50'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFields.emailEjecutivo.label,
                                        "error-messages": _vm.errors.collect(
                                          "emailLeadershipVal"
                                        ),
                                        "data-vv-name": "emailLeadershipVal",
                                        counter: 50,
                                        required: "",
                                        disabled: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.emailEjecutivo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.emailEjecutivo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.emailEjecutivo.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("br"),
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              {
                                attrs: { titulo: "Detalle Propuesta Comercial" }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { sm2: "", md2: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.solucion_id
                                            .label,
                                        items: _vm.solucionesList,
                                        "item-text": "nombre_producto",
                                        "item-value": "id_producto",
                                        clearable: "",
                                        "error-messages": _vm.errors.collect(
                                          "soluciones"
                                        ),
                                        "data-vv-name": "soluciones",
                                        required: ""
                                      },
                                      on: { change: _vm.selectSolu },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.solucion_id
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones
                                              .solucion_id,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.solucion_id.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm2: "", md2: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.modalidad
                                            .label,
                                        items: _vm.modalidadList,
                                        "item-text": "modalidad",
                                        "item-value": "modalidad",
                                        clearable: "",
                                        "error-messages": _vm.errors.collect(
                                          "modalidad"
                                        ),
                                        "data-vv-name": "modalidad",
                                        required: "",
                                        disabled: _vm.disableModalidad
                                      },
                                      on: { change: _vm.handleModalidad },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.modalidad
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.modalidad,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.modalidad.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|numeric",
                                          expression: "'required|numeric'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.cantidad
                                            .label,
                                        type: "text",
                                        "error-messages": _vm.errors.collect(
                                          "cantidad"
                                        ),
                                        "data-vv-name": "cantidad",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.cantidad
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.cantidad,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.cantidad.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { sm2: "", md1: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.plazo.label,
                                        items: _vm.plazoList,
                                        "item-text": "plazo",
                                        "item-value": "plazo",
                                        clearable: "",
                                        disabled:
                                          _vm.formFieldsSoluciones.modalidad
                                            .value == "Venta",
                                        "error-messages": _vm.errors.collect(
                                          "plazo"
                                        ),
                                        "data-vv-name": "plazo",
                                        required: ""
                                      },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.plazo.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.plazo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.plazo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal",
                                          expression: "'required|decimal'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.venta.label,
                                        type: "text",
                                        disabled:
                                          _vm.formFieldsSoluciones.modalidad
                                            .value == "Arriendo",
                                        "error-messages": _vm.errors.collect(
                                          "venta"
                                        ),
                                        "data-vv-name": "venta",
                                        required: ""
                                      },
                                      on: { change: _vm.changeVenta },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.venta.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.venta,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.venta.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal",
                                          expression: "'required|decimal'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.servicio
                                            .label,
                                        type: "text",
                                        "error-messages": _vm.errors.collect(
                                          "servicio"
                                        ),
                                        "data-vv-name": "servicio",
                                        required: ""
                                      },
                                      on: { change: _vm.changeServicio },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.servicio
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.servicio,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.servicio.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal",
                                          expression: "'required|decimal'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.arriendo
                                            .label,
                                        type: "text",
                                        disabled:
                                          _vm.formFieldsSoluciones.modalidad
                                            .value == "Venta",
                                        "error-messages": _vm.errors.collect(
                                          "arriendo"
                                        ),
                                        "data-vv-name": "arriendo",
                                        required: ""
                                      },
                                      on: { change: _vm.changeArriendo },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.arriendo
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones.arriendo,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.arriendo.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c("v-text-field", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required|decimal",
                                          expression: "'required|decimal'"
                                        }
                                      ],
                                      attrs: {
                                        label:
                                          _vm.formFieldsSoluciones.instalacion
                                            .label,
                                        type: "text",
                                        "error-messages": _vm.errors.collect(
                                          "instalacion"
                                        ),
                                        "data-vv-name": "instalacion",
                                        required: ""
                                      },
                                      on: { change: _vm.changeInstalacion },
                                      model: {
                                        value:
                                          _vm.formFieldsSoluciones.instalacion
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFieldsSoluciones
                                              .instalacion,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFieldsSoluciones.instalacion.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md1: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "icon",
                                        staticStyle: {
                                          "padding-right": "20px",
                                          display: "block",
                                          margin: "13px 0 0 auto",
                                          height: "38px"
                                        },
                                        attrs: { color: "#ffe800" },
                                        on: { click: _vm.addSolu }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticStyle: { color: "black" } },
                                          [_vm._v("Agregar")]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md6: "" } },
                                  [
                                    _c("v-textarea", {
                                      attrs: {
                                        label:
                                          _vm.formFields.condicion_comercial
                                            .label,
                                        "no-resize": "",
                                        rules: [
                                          function(v) {
                                            return (
                                              v.length >= 10 ||
                                              v.length === 0 ||
                                              "Ingrese al menos 10 caracteres"
                                            )
                                          },
                                          function(v) {
                                            return (
                                              v.length <= 250 ||
                                              "Solo se permiten 250 caracteres"
                                            )
                                          }
                                        ],
                                        rows: "2"
                                      },
                                      model: {
                                        value:
                                          _vm.formFields.condicion_comercial
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.condicion_comercial,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.condicion_comercial.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("br"),
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { sm2: "", md12: "" } },
                              [
                                _c("DatatableSolu", {
                                  attrs: { dataTable: _vm.dataSolu }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }